import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getStudent,
  studentStatus,
} from "../../../features/slices/studentManagementReducer";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import CommonPagination from "../../CommonPagination";
import ExportToExcel from "../../ExportToExcel";
import { getStudentChallange } from "../../../features/slices/studentManagement/studentChallange";
import TableSkeleton from "../../TableSkeleton";

const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
  category: "",
};
const Challanges = () => {
  const [iState, setUpdateState] = useState(initialState);
  const {
    currentPage,
    searchQuery,
    fromDate,
    toDate,
    timeframe,
    status,
    category,
  } = iState;
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { challange, loading } = useSelector((state) => {
    return state?.studentChallange;
  });
  console.log({ state, challange });

  useEffect(() => {
    dispatch(getStudentChallange({ userId: state?._id ,page}));
  }, [page]);
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getStudentChallange({
            search: searchQuery?.trim(),
            // status: filterStatus,
            userId: state?._id,
          })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(studentStatus(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getStudentChallange({ userId: state?._id })).then((data) => {
          if (data?.payload?.code === 200) {
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          }
        });
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value, userId: state?._id };
    dispatch(getStudentChallange(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          timeframe: "",
        }));
      }
    });
  };
  console.log({ challange });

  const handleFilter = (e) => {
    const status = e.target.value;
    setUpdateState((prev) => ({
      ...prev,
      status: status,
    }));
    if (status == "pin") {
      setUpdateState((prev) => ({
        ...prev,
        is_pinned: true,
      }));
      dispatch(
        getStudentChallange({
          is_pinned: true,
          search: searchQuery?.trim(),
          userId: state?._id,
        })
      );
    } else if (status == "unpin") {
      dispatch(
        getStudentChallange({
          is_pinned: false,
          userId: state?._id,
        })
      );
    } else {
      setUpdateState((prev) => ({
        ...prev,
        filterStatus: status,
      }));
      dispatch(
        getStudentChallange({
          userId: state?._id,
          status: status,
          search: searchQuery?.trim(),
        })
      );
    }
  };
  const handleChangeCategory = (e) => {
    setUpdateState((prev) => ({
      ...prev,
      category: e.target.value,
    }));
    dispatch(
      getStudentChallange({
        categoryId: e.target.value,
        userId: state?._id,
      })
    );
  };
  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudentChallange({ userId: state?._id }));
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      userId: state?._id,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudentChallange(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          searchQuery: "",
          fromDate: "",
          toDate: "",
          timeframe: "",
        }));
      }
    });
  };
  return (
    <div className="tab-pane fade active show" id="ChallengesDetails">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control customSelect"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="DashboardBox Challenges">
        <ul>
          <li>
            <article>
              <aside>
                <p>Total Challenges</p>
              </aside>
              <aside>
                <span className="Icon Orange">
                  <img
                    src={require("../../../assets/images/money-dollar.png")}
                  />
                </span>
                <figcaption>
                  <h3>{challange?.result?.[0]?.totalCount?.[0]?.count}</h3>
                </figcaption>
              </aside>
            </article>
          </li>
          <li>
            <article>
              <aside>
                <p>Total Points Earned</p>
              </aside>
              <aside>
                <span className="Icon Orange">
                  <img
                    src={require("../../../assets/images/money-dollar.png")}
                  />
                </span>
                <figcaption>
                  <h3>{challange?.totalEarnedPoints}</h3>
                </figcaption>
              </aside>
            </article>
          </li>
        </ul>
      </div>
      <div className="NewFilter">
        <div
          className="SearchBox"
          style={{
            width: "60%",
          }}
        >
          <input
            type="search"
            className="SearchInput"
            placeholder="Search here by Id, title, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i className="fa fa-search" />
          </span>
        </div>

        <div className="Actions">
          <div
            className="form-group"
            style={{
              textAlign: "center",
              marginTop: "-1rem",
            }}
          >
            <label
              style={{
                fontWeight: "bolder",
              }}
            >
              Filter by Status
            </label>
            <select
              className="form-control FilterStatus"
              name="category"
              value={category}
              onChange={(e) => handleChangeCategory(e)}
            >
              <option value="" hidden>
                Filter by category
              </option>
              {challange?.result?.[0]?.paginationData?.map((res, i) => {
                return (
                  <option value={res?.categoryId} key={i}>
                    {res?.categoryData?.[0]?.categoryName}
                  </option>
                );
              })}
            </select>
          </div>
          <button className="Button Cancel" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel
            data={challange?.result?.[0]?.paginationData}
            fileName="studentChallangeData"
          />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover" style={{ width: "120%" }}>
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Challenge ID</th>
              <th>Participation ID</th>
              <th>Title of Challenge</th>
              <th>Category </th>
              <th>Enrollment Date</th>
              <th>Submission Date</th>
              <th>Points Earned</th>
              <th>Win Status</th>
              <th>View Submission</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <TableSkeleton />
            ) : challange?.result?.[0]?.paginationData?.length > 0 ? (
              challange?.result?.[0]?.paginationData?.map((res, i) => {
                return (
                  <tr key={res?._id}>
                    <td>{i + 1 + (page - 1) * 10}</td>
                    <td>{res?.challengeData?.[0]?.challenge_number}</td>
                    <td>P-101</td>
                    <td>{res?.challengeData?.[0]?.title}</td>
                    <td>{res?.categoryData?.[0]?.categoryName}</td>
                    <td>25/05/2024</td>
                    <td>{moment(res?.submitAt).format("DD/MM/YYYY")}</td>
                    <td>{res?.studentPoints}</td>
                    <td>
                      <span className="Yellow">Under Review</span>
                    </td>
                    <td>
                      <div className="Actions">
                        <Link
                          to={"/challenges/submissionDetail?type=student"}
                          className="Eyes"
                          state={{
                            ...res,
                            studentData: { fullName: state?.fullName },
                          }}
                        >
                          <i className="fa-regular fa-eye" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={10}>No Challanges Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {challange?.result?.[0]?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {challange?.result?.[0]?.paginationData?.length + (page - 1) * 10}{" "}
              of {challange?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {challange?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    challange?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Challanges;
